'use strict';

/**
 * Filter component view
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var FilterComponentView = require('modules/base/views/layout/filter-component');

var template = require('modules/collection/templates/components/filter/size.hbs');

var SizeView = FilterComponentView.extend({
    template: template,

    ui: {
        'multipleOptions': '.component-filter-buttons input[type="checkbox"]',
    },

    events: {
        'change @ui.multipleOptions': 'change',
    },

    sizesAvailable: [
        'micromount',
        'thumbnail',
        'miniature',
        'smallCabinet',
        'cabinetSpecimen',
        'museumSpecimen',
    ],

    viewData: {
        availableSizes: function() {
            return this.sizesAvailable;
        },
    },

    getFilterValueDisplayName: function(value) {
        return App.t('collection::object:dimension-type:' + value);
    },

    getFilters: function() {
        var filters = [];

        var multipleOptions = this.ui.multipleOptions.filter(':checked');

        multipleOptions.each(function(index, option){
            option = $(option);
            filters.push({value: option.val(), displayName: option.next('label').text().trim()});
        });

        return filters;
    },

    setFilters: function(filters) {
        filters = filters.split(',');

        this.ui.multipleOptions.each(function(index, option){
            $(option).prop('checked', _.contains(filters, $(option).val()));
        });
    },

    resetFilters: function() {
        this.ui.multipleOptions.each(function(index, option){
            $(option).prop('checked', false);
        });

        this.change();
    },
});

module.exports = SizeView;